import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom'
import { BrowserRouter as Router, browserHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import ModuleQVAppContainer from '../module-quick-view-app/moduleQVAppContainer'

function AppContainer(props){
  let{urlInfo} = props
  return(
    <Router>
      {window.location.hostname === 'mqv.autoipacket.com' && window.location.pathname === '/' && (
            window.location.href="https://ipacket.us"
      )}
      <ModuleQVAppContainer/>
    </Router>
  )
}

const mapStateToProps = state => ({
  urlInfo:state.urlInfo
})
export default connect(mapStateToProps)(AppContainer)
